<template>
    <div v-if="loading" class="loading-overlay">
        <div class="loading-container">
        <div class="spinner mt-3"></div>
        <div class="loading-text">Seohan</div>
        </div>
    </div>
    <div class="container-fluid mt-4 py-3">
        <!-- <div class="box top-box mb-10 p-3 rounded-3 bg-white d-flex align-items-center shadow">
            <h4 class="font-weight-bold">Inovice Issuance</h4>
        </div> -->
        <div class="">
        <p class="custom-text-h4 font-weight-bold text-black ma-2">Invoice Issuance</p>
        <p class="font-weight-bold ml-5 mt-0 text-gray">
          <v-icon icon="mdi-sort-reverse-variant" class="mr-2"></v-icon>Order Management >
          Invoice Issuance
        </p>
      </div>

            <div class="search-container mb-4">
                <v-row class="d-flex align-items-center">
                    <!-- Part Name 입력 필드 -->
                    <v-col cols="5" class="pr-2">
                        <div class="split-box">
                            <div class="label-box">Part Name / Part Number</div>
                            <div class="select-box1">
                            <v-text-field
                                v-model="search.query"
                                
                                placeholder="Enter Part Name or Part Number"
                                dense
                                variant="plain"
                                hide-details
                            />
                            </div>
                        </div>
                        </v-col>
                        <v-col cols="2" class="pr-2 ">
                        <v-menu offset-y>
                            <template v-slot:activator="{ props }">
                            <div class="split-box2" v-bind="props">
                                <div class="label-box2">Location</div>
                                <div class="select-box2">{{ search.location }}</div>
                            </div>
                            </template>
                            <v-list>
                            <v-list-item
                                v-for="(item, index) in locationOptions"
                                :key="index"
                                @click="search.location = item"
                            >
                                <v-list-item-title>{{ item }}</v-list-item-title>
                            </v-list-item>
                            </v-list>
                        </v-menu>
                        </v-col>
                        <v-col cols="2" class="d-flex align-items-center" style="padding-left: 3px">
                            <!-- 라벨 박스만 따로 -->
                            <div class="label-box date-label-box ml-5">Departure Date</div>

                            <!-- date picker 2개 나란히 -->
                            <div class="d-flex align-center mb-2" style="gap: 0px;" >
                                <vue-datepicker 
                                v-model="date1"
                                model-type="yyyy-MM-dd"
                                class="custom-datepicker"
                                placeholder="Start Date"
                                :text-input="textInputOptions"
                                :enable-time-picker="false"
                                :auto-apply="true"
                                format="yyyy-MM-dd"
                                />
                            </div>
                        </v-col>
                    <v-col cols="3" class="d-flex align-center justify-end" style="gap: 10px;">
                        <!-- Pallet Label 버튼 (조건부 표시) -->
                        <v-btn 
                            v-if="username === 'P0209'"
                            color="green"
                            :disabled="selectedItems.length === 0"
                            @click="openModal2"
                        >
                            Pallet Label
                        </v-btn>

                        <!-- Confirm 버튼 -->
                        <v-btn 
                            color="primary"
                            :disabled="selectedItems.length === 0"
                            @click="openModal"
                        >
                            Confirm
                        </v-btn>
                    </v-col>
                </v-row>
            </div>

        <v-card class="pa-4 custom-card" elevation="2">

            

            <!-- ✅ 검색 필터 (가로 정렬) -->
            
            <div class="d-flex align-items-center mb-3 ">
                <span class="ml-2 mr-6 font-weight-bold text-muted small">
                    * To proceed, select the POs you need and click the Confirm button.
                </span>
            </div>

            <!-- ✅ 테이블 (체크박스 추가) -->
            <v-data-table
                v-model="selectedItems"
                :headers="computedHeaders"
                :items="filteredItems"
                item-value="poDetail"
                height="560"
                density="compact"
                fixed-header
                show-select
                hover
                v-model:items-per-page="itemsPerPage"
            >
                <template #[`item`]="{ item }">
                    <tr class="data-table-row">
                        <!-- 체크박스 열 -->
                        <td class="text-center">
                            <v-checkbox
                                v-model="selectedItems"
                                :value="item.poDetail"
                                hide-details
                                density="compact"
                            ></v-checkbox>
                        </td>
                        <td
                        v-if="isMobisUser"
                        class="text-center"
                        :style="{
                            backgroundColor: item.category === 'AL' ? '#FFE0B2' 
                                            : item.category === 'GA' ? '#C8E6C9' 
                                            : '#FFFFFF',
                            color: '#000000',
                            fontWeight: 'bold'
                        }"
                        >
                        {{ item.category }}
                        </td>





                        <td class="text-center font-weight-bold" >{{ item.poDetail }}</td>
                        <td class="text-center">{{ item.poDate }}</td>
                        <td class="text-center">{{ item.poEndDate }}</td>
                        <td class="text-center">{{ item.partNumber }}</td>
                        <td class="text-center">{{ item.partName }}</td>
                        <td class="text-center">{{ item.location }}</td> <!-- ✅ 추가 -->
                        <td class="text-right">{{ formatNumber(item.poQty) }}</td>
                        <td class="text-right">{{ formatNumber(item.receivedQty) }}</td>
                        <td class="text-right font-weight-bold">{{ formatNumber(item.remainQty) }}</td>
                    </tr>
                </template>
                
            </v-data-table>
        </v-card>
        <InvoiceIssuanceDetail
            v-if="isHistoryModalVisible"
            :po_no="selectedPoDetails"
            :username="username"
            :location="modalLocation" 
            :category="category"
            :departureDate="date1" 
            @close-modal="handleCloseModal"
            class="custom-modal-size"
        />
        <PalletLabel
            v-if="isPalletLabelModalVisible"
            :selectedPalletData="selectedPalletData"
            :username="username"
            :departureDate="date1"
            @close-modal="isPalletLabelModalVisible = false"
            class="custom-modal-size2"
        />
    </div>
</template>

<script>
import axios from "axios";

import { mapState } from "vuex";
import InvoiceIssuanceDetail from "@/components/Ui/InvoiceIssuanceDetail";
import PalletLabel  from "@/components/Ui/PalletLabel";

import "@vuepic/vue-datepicker/dist/main.css";
import VueDatepicker from "@vuepic/vue-datepicker";

export default {
    components: {
        InvoiceIssuanceDetail,
        VueDatepicker,
        PalletLabel  
    },
   data() {
        const today = new Date();
        today.setMinutes(today.getMinutes() - today.getTimezoneOffset()); // 🔥 타임존 보정
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const todayString = `${yyyy}-${mm}-${dd}`;
        return {
            category: '', // ✅ 모달용 category 전달용
            isPalletLabelModalVisible: false,
            selectedPalletData: [],
            itemsPerPage: 12,
            selectedItems: [], // ✅ 선택된 항목 저장
            selectedPoDetails: [],
            isHistoryModalVisible: false,
            search: {
                query: "", // ✅ 검색어 저장
                location: "ALL"
            },
            locationOptions: ["ALL"],
            warehouseNameMap: {},
            mobisUserList: [],
            
            headers: [

                { title: "PO Number Detail", key: "poDetail", align: "center", sortable: true },
                { title: "Date", key: "poDate", align: "center", sortable: true },
                { title: "End Date", key: "poEndDate", align: "center", sortable: true },
                { title: "Part Number", key: "partNumber", align: "center", sortable: true },
                { title: "Part Name", key: "partName", align: "center", sortable: true },
                { title: "Location", key: "location", align: "center", sortable: false }, // ✅ 추가\
                { title: "PO QTY", key: "poQty", align: "center", sortable: false },
                { title: "Shipped QTY", key: "receivedQty", align: "center", sortable: false },
                { title: "Remain QTY", key: "remainQty", align: "center", sortable: false },
            ],
            items: [],
            modalLocation: '',  // 🔹 추가
            date1 : todayString,
        };
    },
    computed: {

        ...mapState({
        username: (state) => state.username, // Vuex 상태에서 username 가져오기
        }),
        isMobisUser() {
            return this.mobisUserList
                .map(code => String(code).toLowerCase())
                .includes(String(this.username || "").toLowerCase());
        },
        filteredItems() {
            return this.items.filter(item => {
                const matchQuery =
                !this.search.query ||
                item.partName.toLowerCase().includes(this.search.query.toLowerCase()) ||
                item.partNumber.toLowerCase().includes(this.search.query.toLowerCase());

                const matchLocation =
                this.search.location === "ALL" || item.location === this.search.location;

                return matchQuery && matchLocation;
            });
        },
        computedHeaders() {
            const baseHeaders = [...this.headers];
            if (this.isMobisUser) {
            baseHeaders.splice(0, 0, { title: "Category", key: "category", align: "center", sortable:true });
            }
            return baseHeaders;
        }

    },
    watch: {
        date1() {
            //console.log("📅 Departure Date 변경됨:", newVal);
            this.selectedItems = [];
            this.invoiceIssuanceMainPage();
        }
    },
    methods: {
        openModal2() {
            if (this.selectedItems.length === 0) {
                console.error("❌ No items selected!");
                return;
            }
            
            // ✅ 선택된 item 객체들 가져오기
            const selectedData = this.items.filter(item =>
                this.selectedItems.includes(item.poDetail)
            );

            // ✅ PalletLabel.vue 에 넘길 값 세팅
            this.selectedPalletData = selectedData;

            //console.log("📦 Pallet Label Selected Data:", this.selectedPalletData);

            // ✅ PalletLabel 모달 열기
            this.isPalletLabelModalVisible = true;
        },
        formatNumber(value) {
            if (!value) return "0"; // 값이 없으면 0 리턴
            return Number(value).toLocaleString(); // 천 단위 콤마 추가
        },
        handleCloseModal() {
            this.isHistoryModalVisible = false; // 모달 닫기
            this.$nextTick(() => {
                this.invoiceIssuanceMainPage();
            });
        },
        async invoiceIssuanceMainPage() {
            this.loading = true; // ✅ API 호출 전 로딩 활성화
            try {
                //console.log("📌 Invoice Issuance Main Page 데이터 로딩 시작");
                 if (!this.date1) {
                    alert("❗ Check the departure date.");
                    return;
                }
                // ✅ API 요청 (예제)
                const formattedDate1 = this.date1.replace(/-/g, '');
                const response = await axios.get("/api/getInvoiceIssuanceMainPage", {
                    params: { username: this.username, date1: formattedDate1},
                });
                //console.log(response);
                if (response.data.success) {
                    this.items = response.data.orders.map(order => {
                    const location = this.getWarehouseDisplayName(order.DOCK_NO);
                    
                    return {
                        category: order.PO_GB,
                        poDetail: order.PO_NO_DTL,
                        poDate: this.formatDate(order.PO_YMD),
                        poEndDate: this.formatDate(order.REQ_YMD),
                        partNumber: order.ITEM_NO,
                        partName: order.ITEM_NM,
                        location, // ✅ location 추가
                        poQty: order.PO_QTY,
                        receivedQty: order.RP_QTY,
                        remainQty: Math.max(order.PO_QTY - order.RP_QTY, 0)
                    };
                    });
                    //console.log("✅ 데이터 로드 완료:", this.items);
                } else {
                    console.error("❌ 데이터 로드 실패");
                    this.items = [];
                }
            } catch (error) {
                console.error("❌ API 요청 중 오류 발생:", error);
            } finally {
                this.loading = false; // ✅ 로딩 종료
            }
        },
        formatDate(dateString) {
            if (!dateString) return "";
            const strDate = dateString.toString();
            return `${strDate.substring(0, 4)}-${strDate.substring(4, 6)}-${strDate.substring(6, 8)}`;
        },
        openModal() {
            if (this.selectedItems.length === 0) {
                console.error("❌ No items selected!");
                return;
            }
             // ✅ 선택된 item 객체들 가져오기
             const selectedData = this.items.filter(item =>
                this.selectedItems.includes(item.poDetail)
            );
            // ✅ 모든 선택 항목의 location이 동일한지 확인
            const locationSet = new Set(selectedData.map(item => item.location));
            if (locationSet.size > 1) {
                alert("❗ Multiple Locations selected.\nPlease select POs from the same Location only.");
                return;
            }
            if (this.isMobisUser) {
                const categories = new Set(selectedData.map(item => item.category));
                const hasAL = categories.has("AL");
                const hasGA = categories.has("GA");

                if (hasAL && hasGA) {
                    alert("❌ AL and GA cannot be selected together.\n(Shared can be selected with either AL or GA)");
                    return;
                }
             // ✅ 새로운 category 계산 로직
                if (hasAL) {
                    this.category = 'AL';
                } else if (hasGA) {
                    this.category = 'GA';
                } else {
                    this.category = 'Shared';
                }
            } else {
                this.category = ''; // non-special users
            }
            this.modalLocation = selectedData[0].location;

            // ✅ 선택된 항목의 PO Number Detail을 저장
            this.selectedPoDetails = [...this.selectedItems]; 
            //console.log("📌 Selected PO Numbers:", this.selectedPoDetails);
            //console.log("📅 Current Departure Date:", this.date1); // ✅ 여기서 찍어봐

            // ✅ 모달 열기
            this.isHistoryModalVisible = true;
        },
        async fetchWarehouseNames() {
            try {
                const response = await axios.get("/api/getWarehouseName");
                const rows = response.data.data || [];
                const names = rows
                    .map(row => String(row.AREF1 || row.name || row.ASDES || row).trim())
                    .filter(Boolean);

                if (names.length > 0) {
                    this.locationOptions = ["ALL", ...new Set(names)];
                }

                this.warehouseNameMap = rows.reduce((map, row) => {
                    const code = String(row.ASDES || row.CODE || row.CODE_CD || row.value || "").trim();
                    const name = String(row.AREF1 || row.name || row.ASDES || "").trim();

                    if (code && name) {
                        map[code] = name;
                    }

                    return map;
                }, {});
            } catch (error) {
                console.error("❌ getWarehouseName API 호출 오류:", error);
            }
        },
        async fetchMobisUserList() {
            try {
                const response = await axios.get("/api/getGaAlCompany");
                const rows = response.data.result || [];

                this.mobisUserList = rows
                    .map(row => String(row.ASDES || row).trim())
                    .filter(Boolean);
            } catch (error) {
                console.error("❌ getGaAlCompany API 호출 오류:", error);
                this.mobisUserList = [];
            }
        },
        getWarehouseDisplayName(dockNo) {
            const code = String(dockNo || "").trim();
            return this.warehouseNameMap[code] || code;
        }


        
    },
    

    async mounted() {
        await Promise.all([
            this.fetchWarehouseNames(),
            this.fetchMobisUserList()
        ]);
        this.invoiceIssuanceMainPage();
    }
}
</script>


<style scoped>


.modal-dialog {
  margin-top: 1000px; /* 원하는 값으로 조정 (기본값: auto) */
}

.custom-select {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: white;
    border-radius: 4px;
    padding: 21px 20px;
    cursor: pointer;
    font-size: 16px;
    width: 275px;
    }
.custom-input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    padding-left: 12px;
    }

    .custom-value {
    flex: 1;
    text-align: left;
    color: #374151;
    padding-left: 20px;
    }

    /* ✅ Vuetify 기본 입력 필드 테두리, 그림자 제거 */
    .custom-input .v-input__control {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    min-height: 0 !important; /* ✅ 불필요한 높이 제거 */
    height: 100% !important;
    }

    /* ✅ 숫자 필드의 기본 스핀 버튼 완전 제거 */
    .custom-input input {
    -moz-appearance: none !important; /* Firefox */
    -webkit-appearance: none !important; /* Chrome, Safari */
    appearance: none !important;
    height: auto !important;
    min-height: unset !important;
    padding: 0 !important;
    text-align: left;
    background: transparent !important; /* ✅ 배경 투명화 */
    border: none !important; /* ✅ 테두리 제거 */
    box-shadow: none !important; /* ✅ 불필요한 박스 제거 */
    }

    /* ✅ Vuetify에서 자동 생성되는 불필요한 UI 요소 제거 */
    .custom-input .v-input__control::before,
    .custom-input .v-input__control::after {
    display: none !important;
    box-shadow: none !important;
    border: none !important;
    }

    /* ✅ v-text-field 내부 입력 필드 정렬 */
    .custom-input .v-input__control {
    display: flex !important;
    align-items: center !important;
    }

    /* ✅ 불필요한 여백 제거 */
    .custom-input input {
    margin: 0 !important;
    padding: 0 !important;
    }
    
 .custom-label2 {
    color: #6b7280;
    font-weight: 500;
    margin-right: 12px;
    position: relative;
    padding-right: 12px;
    
    }

    .custom-label2::after {
    content: "";
    position: absolute;
    left: 210px;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 173%;
    background-color: #d1d5db;
    }
    .custom-label3::after {
    content: "";
    position: absolute;
    left: 85px;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 179%;
    background-color: #d1d5db;
    }
    .container-input {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: white;
    border-radius: 4px;
    padding: 12px 15px;
    font-size: 16px;
    width: 550px;
    height: 45px;
    }
.custom-width {
    max-width: 300px;
}

/* 배경색 적용 */
.custom-bg ::v-deep(.v-input__control) {
    background-color: rgb(255, 255, 255) !important;
}


.data-table-row:hover {
    background-color: #f5f5f5;
    cursor: pointer;
}

:deep() .v-data-table thead th {
    font-weight: bold !important; /* 헤더 텍스트 굵게 */
    text-align: center; /* 중앙 정렬 */
}


:deep() .v-table .v-table__wrapper > table > thead > tr > th {
    border: thin solid rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}
:deep() .v-table .v-table__wrapper > table > tbody > tr > td {
    border: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}

.custom-text-h4 {
        font-size: 3rem !important;
        font-weight: 400;
        line-height: 2.5rem;
        text-transform: none !important;
    }


    /* 헤더 강조 */
:deep() .v-data-table thead th {
  background-color: #e3f2fd !important; /* 연한 파랑 */
  font-weight: bold !important;
  text-align: center;
}

/* 테이블 줄무늬 */
:deep() .v-data-table tbody tr:nth-child(odd) {
  background-color: #ffffff; /* 흰색 */
}
:deep() .v-data-table tbody tr:nth-child(even) {
  background-color: #f5f5f5; /* 회색 */
}

/* 테이블 테두리 */
:deep() .v-table .v-table__wrapper > table > thead > tr > th {
  border: thin solid rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}
:deep() .v-table .v-table__wrapper > table > tbody > tr > td {
  border: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}

/* 모든 셀 중앙 정렬 */
:deep() .v-data-table tbody td {
  text-align: center;
}

/* 체크박스 있는 첫 번째 열만 따로 정렬 */
:deep() .v-data-table tbody td:first-child {
  text-align: center;
}

:deep() .v-data-table thead th {
  font-size: 16px !important; /* 헤더 텍스트 크기 증가 */
  font-weight: bold !important;
}

:deep() .v-data-table tbody td {
  font-size: 14px !important; /* 본문 텍스트 크기 증가 */
  font-weight: 500;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 9999;
}
.loading-container {
  display: flex;
  align-items: center;
  gap: 15px; /* 스피너와 텍스트 간격 */
}

/* ✅ 빙글빙글 도는 스피너 */
.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(0, 123, 255, 0.3);
  border-top: 5px solid #007bff;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

/* ✅ 스피너 애니메이션 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* ✅ 출렁이는 색상 변화 효과 */
.loading-text {
  font-size: 64px;
  font-weight: bold;
  text-transform: uppercase;
  background: linear-gradient(120deg, #ffffff, #007bff, #ffffff);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  color: transparent;
  animation: waveColor 3s ease-in-out infinite;
}

/* ✅ 출렁이는 애니메이션 */
@keyframes waveColor {
  0% {
    background-position: 0% 70%;
  }
  50% {
    background-position: 100% 30%;
  }
  100% {
    background-position: 0% 70%;
  }
}/* QTY 숫자 컬럼 오른쪽 정렬 */
:deep() .v-data-table tbody td:nth-child(10), /* PO QTY */
:deep() .v-data-table tbody td:nth-child(11), /* Received QTY */
:deep() .v-data-table tbody td:nth-child(9)  /* Remain QTY */ {
    text-align: right !important;
    width: 15vh;
}

@font-face {
    font-family: 'HyundaiSans2';
    src: url('../../assets/fonts/HyundaiSansHeadKRMedium.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRLIGHT.TTF') format('truetype');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'hyundai2';
    src: url('../../assets/fonts/hundai-M.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
}
@font-face {
    font-family: 'hyundai';
    src: url('../../assets/fonts/hyundai-L.ttf') format('truetype');
    font-style: normal;
}
/* ✅ 전체 애플리케이션의 기본 폰트로 적용 */
* {
    font-family: 'hyundai' !important;
}


.select-box1 {
  flex: 1;
  padding-left: 16px;
  display: flex;
  align-items: center;
  color: #374151;
  cursor: pointer;
  font-weight: bold;
  padding-top: 4px; /* ✅ 위쪽 여백 줄이기 */
}

.label-box {
  background-color: #f4f4f4;
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #374151;
  white-space: nowrap;
  border-right: 1px solid #d1d5db;
  height: 45px;
}
.split-box {
  display: flex;
  width: 100%;
  height: 45px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  overflow: hidden;
  font-size: 16px;
  background-color: white;
}
.split-box2 {
  display: flex;
  width: 95%;
  height: 45px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  overflow: hidden;
  font-size: 16px;
  background-color: white;
}
.select-box2 {
  flex: 1;
  padding-left: 16px;
  display: flex;
  align-items: center;
  color: #374151;
  cursor: pointer;
}
.label-box2 {
  background-color: #f4f4f4;
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #374151;
  white-space: nowrap;
  border-right: 1px solid #d1d5db;
}
:deep(.v-field__input) {
  padding-top: 4px !important; /* Vuetify 기본 padding-top 제거 */
  padding-bottom: 4px !important; /* Vuetify 기본 padding-top 제거 */

}

.container-fluid {
  height : 95%;
  overflow-y: auto;
}

.custom-card {
  max-width: 100%;  /* 원하는 최대 너비 설정 */
  width: 100%;        /* 화면 크기에 맞게 자동 조절 */
  height: 90%;
}

/* 예시: 모달 크기 조정 */
:deep(.custom-modal-size) {
  width: 100% !important;   /* 너비 조정 (뷰포트 기준) */
  height: 80% !important;  /* 높이 조정 (뷰포트 기준) */
}
:deep(.custom-modal-size2) {
  width: 5% !important;   /* 너비 조정 (뷰포트 기준) */
  height: 5% !important;  /* 높이 조정 (뷰포트 기준) */
}
.date-label-box {
  background-color: #f4f4f4;
  height: 45px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #374151;
  white-space: nowrap;
  border: 1px solid #d1d5db;
  border-radius: 4px 0 0 4px;
  border-right: none;
}
/* 메인 테이블 숫자 컬럼 오른쪽 정렬 */
.custom-datepicker {
    width: 150px; /* 원하는 너비 조정 */
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
    top: -1px;
    height: 35px;

}

:deep(.dp__input) {
    width: 150px !important;
    height: 45px !important;
    border-radius: 5px !important;
    padding: 5px 2px !important;
    text-align: center !important;
    font-size: 14px !important;
    border-top-left-radius: 0% !important;
        border-bottom-left-radius: 0% !important;
        border-top-right-radius: 4px !important;
        border-bottom-right-radius: 4px !important;
}
</style>
